"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMoveWindow = formatMoveWindow;
exports.isSpentOnArrival = isSpentOnArrival;
/**
 * The satellite move window as the phrase that completes "move the excess …".
 * A zero-day window means the excess must leave within the shift in which the
 * cap was crossed, so it reads as that rather than as "within 0 days".
 */
function formatMoveWindow(days) {
    if (days === 0) {
        // note: this is specific to Delaware, as that is the only state
        // we know of so far that has a different time constraint on the move window.
        // This is acceptable ONLY so long as Delaware is the ONLY exception.
        //
        // If other states customize it in different ways, this should
        // be refactored so that the "move window customer-facing copy chunk"
        // (probably just named `moveWindowCopy`) is calculated as part of the
        // accumulation ruleset and added to the return type there. We should NOT layer on
        // hacks in here; change this function to accept a second parameter of `state`;
        // or anything else less than a single, explicit, well-modularized and colocated
        // home for both the "moveWindowDays" number and what that number means
        return "before the end of the shift";
    }
    return `within ${days} ${days === 1 ? "day" : "days"}`;
}
/**
 * Whether a limit's countdown would misstate it: a window granting no time
 * past the crossing has nothing to count down until it is actually late.
 *
 * Takes a limit's total length rather than a move window directly, because the
 * container surfaces only ever see the former. Zero identifies a move window
 * there without a flag of its own — every other limit the engine builds
 * carries a real span (90/180/270/365 for a residence clock, 60 for an
 * episodic window) or none at all.
 */
function isSpentOnArrival(totalDays, daysRemaining) {
    return totalDays === 0 && daysRemaining != null && daysRemaining >= 0;
}
//# sourceMappingURL=formatMoveWindow.js.map